import { AriseFeesTemplateFields } from "globalConstants";
import { FeeTemplatesStatusTypes } from "types";

const ZERO = "0.000000";

export const ariseFeeTemplateInitialValues = {
	[AriseFeesTemplateFields.IsDefault.name]: false,
	[AriseFeesTemplateFields.Status.name]: FeeTemplatesStatusTypes.Available,
	[AriseFeesTemplateFields.TemplateName.name]: "",
	[AriseFeesTemplateFields.PlatformSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.PlatformMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.CustomerVaultMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.EnhancedDataTransactionFee.name]: ZERO,
	[AriseFeesTemplateFields.CardTransactionAuthorizationFee.name]: ZERO,
	[AriseFeesTemplateFields.ECommercePluginSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.ECommercePluginMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.EMVDeviceSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.AdditionalEmvDeviceMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.EnhancedDataSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.CustomerVaultSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.CustomerVaultAutomaticUpdateFee.name]: ZERO,
	[AriseFeesTemplateFields.MobileInvoicingPaymentsSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.MobileInvoicingPaymentsMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.MobileInvoicingPaymentsMessageFee.name]: ZERO,
	[AriseFeesTemplateFields.CardNetworkTokenizationToggle.name]: false,
	[AriseFeesTemplateFields.CardNetworkTokenizationSetupFee.name]: ZERO,
	[AriseFeesTemplateFields.CardNetworkTokenizationMonthlyFee.name]: ZERO,
	[AriseFeesTemplateFields.CardNetworkTokenizationPerItemFee.name]: ZERO,
};
